import React from 'react';

import MarkerCluster from '../../lib/markerclusterer/src/markerclusterer';
import { Utilities } from './utilities.js';
import { ClosestDealers } from './closestDealers/closestDealers.js';
import { PlacesSearchBox } from './closestDealers/placesSearchBox.js';
import { getRegion } from './api/apiMethods.js';
import { setCountryTooltip, showCountryTooltip, hideCountryTooltip, setCountryTooltipText } from './mapHelpers/countryTooltip.js';
import { addMapEventListeners, clearMapEventListeners } from "./mapHelpers/mapEventListeners.js";
import { setClickableRegions, revertClickableRegionsStyle } from "./mapHelpers/regionDataHelpers.js";
import { getClosestDealers, sortDealersWithDirections} from "./mapHelpers/directionsHelpers.js";

const clustermarkerImagePath = "/Frontend/Images/m";
const markerIconDealer = "/Frontend/images/map-marker-Dealer.svg";
const markerIconContact = "/Frontend/images/map-marker-Contact.svg";
const geoJson = "/Frontend/geodata/geo.json";
const mapStylingRegion = [
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [{ "color": "#f3f2f1" }]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [{ "color": "#deefdc" }]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{ "color": "#cddceb" }]
    },
    {
        "featureType": "poi",
        "stylers": [{ "visibility": "off" }]
    },
    {
        "featureType": 'transit',
        "elementType": 'labels.icon',
        "stylers": [{ "visibility": 'off' }]
    }
];
const mapStylingInternational =
[
    { "featureType": "all", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] },
    { "featureType": "all", "elementType": "labels", "stylers": [{ "visibility": "off" }] },
    { "featureType": "administrative", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#dbd6c6" }] },
    { "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }] },
    { "featureType": "landscape", "elementType": "all", "stylers": [{ "hue": "#4600ff" }] },
    { "featureType": "landscape", "elementType": "geometry","stylers": [{ "visibility": "on" }, { "color": "#ffffff" }]},
    { "featureType": "landscape", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ff0000" }] },
    { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "landscape.natural", "elementType": "all", "stylers": [{ "visibility": "on" }] },
    { "featureType": "landscape.natural.landcover", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "road", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] },
    { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#f6f3f0" }, { "visibility": "on" }] }
];

export class Map extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            modalIsOpen: false,
            activeDealer: {},
            showClosestDealers: false,
            closestDealers: [],
            searchOrigin: null,
            closestDealersBounds: null,
            geoLocationSuccess: false,
            noDealersFound: false
    };
        this.markers = [];
        this.map = undefined;
        this.markerClusters = [];
        this.mapElement = null;
        this.searchOriginAddress = "";
        this.searchBox = undefined;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            geoLocationSuccess: nextProps.geoLocationSuccess
        });
        if (this.props.activeRegion !== nextProps.activeRegion) {
            this.searchOriginAddress = "";
            this.setState({
                closestDealers: [],
                showClosestDealers: false,
                noDealersFound: false
        });
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if (this.props.activeRegion !== nextProps.activeRegion) {
            return true;
        }
        else if ((this.state.searchOrigin !== nextState.searchOrigin)) {
            return true;
        }
        else if (this.state.geoLocationSuccess !== nextState.geoLocationSuccess) {
            return true;
        }
        else if (this.state.noDealersFound !== nextState.noDealersFound) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        setCountryTooltip();
    }

    componentDidUpdate() {
        if (this.map === undefined && window.google !== undefined) {
            this.createMap();
        }  else {
            this.initMap();
        }
    }

    render() {
        let closestDealersExpanded = null;
        if (this.state.closestDealers.length) {
            closestDealersExpanded = "expanded";
        }
        if (this.props.activeRegion.IsInternational || this.props.loadingDealers) {
            return (
                <div className="map-wrapper">
                    <div></div>
                    <div ref={(map) => { this.mapElement = map; }} id="map"></div>
                </div>
            );
        } else {
            return (
                <div className="map-wrapper">
                    <div id="closestDealers" className={closestDealersExpanded}>
                    <ClosestDealers
                        searchOriginAddress={this.searchOriginAddress}
                        noDealersFound={this.state.noDealersFound}
                        closestDealers={this.state.closestDealers}
                        onDealerClick={this.props.onDealerClick} />
                    </div>
                    <div ref={(map) => { this.mapElement = map; }} id="map"></div>
                </div>
            );
        }
    }

    createMap() {
        this.map = new google.maps.Map(this.mapElement, {
            zoom: 3,
            center: {lat:0, lng:0},
            styles: mapStylingInternational,
            disableDefaultUI: true
        });

        this.map.data.loadGeoJson(geoJson, {}, () => {
            this.map.data.setStyle({
                fillColor: '#c2242a',
                fillOpacity: 0,
                strokeOpacity: 0.0,
                cursor: 'default'
            });
            setClickableRegions(this.props.regions, this.map);
            if (!this.props.activeRegion.IsInternational) {
                this.map.data.revertStyle();
            } else {
                this.initMap();
                this.initPlacesSearchBox();
            }
        });
    }

    createSearchBox()
    {
        var textInputElement = document.getElementById('small-search-box');
        this.searchBox = new google.maps.places.Autocomplete(textInputElement);
        this.searchBox.addListener('place_changed', this.handlePlacesSearch.bind(this, this.searchBox));
    }

    initMap() {
        if(!Utilities.isEmpty(this.props.activeRegion) && this.map !== undefined){
            let dealers = this.getActiveRegionDealers(this.props.activeRegion);
            let contacts = this.getActiveRegionContacts(this.props.activeRegion);
            let countryName = document.getElementById("countryName");

            //Clear map
            this.clearMarkers();

            if (this.state.geoLocationSuccess) {
                let userLocation = this.props.userLocation;
                var closestDealers = getClosestDealers(dealers, userLocation);
                var closestDealersBounds = new google.maps.LatLngBounds();
                closestDealersBounds.extend(userLocation);
                this.searchOriginAddress = this.props.userLocationAddress;
                this.getDirectionDistanceToDealers(closestDealers, userLocation, closestDealersBounds);
            }

            if (this.state.showClosestDealers) {
                clearMapEventListeners(this.map);
                if(dealers != null){
                    this.createMarkersForDealers(dealers);
                }
                if(contacts != null){
                    this.createMarkersForContacts(contacts);
                }
                this.createSearchOriginMarker(this.state.searchOrigin);
                this.fitToMarkers(this.state.closestDealersBounds);
            } else {
                var zoom = this.props.activeRegion.Zoom;
                var center = { lat: this.props.activeRegion.Lat, lng: this.props.activeRegion.Long };
                this.map.setCenter(center);
                this.map.setZoom(zoom);

                if (this.props.activeRegion.IsInternational) {
                    this.map.setOptions({ styles: mapStylingInternational });
                    revertClickableRegionsStyle(this.map);
                    addMapEventListeners(this.map, this.props.onRegionClick);
                } else {
                    if (this.props.activeRegion.IsPersonRegion || this.props.activeRegion.IsDealerRegion) {
                        if (this.searchBox === undefined) {
                            this.createSearchBox();
                        }
                        this.initPlacesSearchBox();
                    } else {
                        this.searchBox = undefined;
                    }
                    clearMapEventListeners(this.map);
                    this.map.data.revertStyle();
                    this.map.setOptions({ styles: mapStylingRegion });
                    if (contacts != null){
                        this.createMarkersForContacts(contacts);
                    }
                    if (dealers != null){
                        this.createMarkersForDealers(dealers);
                    }

                    countryName.style.visibility = "hidden";
                }
            }
        }
    }

    initPlacesSearchBox() {
        if (this.searchBox !== undefined) {
            this.searchBox.setComponentRestrictions({ country: this.props.activeRegion.RegionIsoCode.toUpperCase() });
        }
    }

    handlePlacesSearch(searchBox)
    {
        var place = searchBox.getPlace();
        if (!place.geometry) {
            return;
        }
        this.searchOriginAddress = place.formatted_address;
        var dealers = this.getActiveRegionDealers(this.props.activeRegion);
        var userLocation = place.geometry.location;
        var closestDealers = getClosestDealers(dealers, userLocation);
        var closestDealersBounds = new google.maps.LatLngBounds();
        closestDealersBounds.extend(userLocation);
        if (!closestDealers.length) {
            this.setState({
                showClosestDealers: true,
                geoLocationSuccess: false,
                noDealersFound: true,
                closestDealers: [],
                searchOrigin: userLocation,
                closestDealersBounds: closestDealersBounds
            });
            return;
        }
        this.getDirectionDistanceToDealers(closestDealers, userLocation, closestDealersBounds);
        this.props.handleSearch();
    }

    getActiveRegionDealers(activeRegion)
    {
        let dealers = null;
        if (activeRegion.IsDealerRegion) {
            dealers = activeRegion.Dealers;
        }
        return dealers;
    }

    getActiveRegionContacts(activeRegion) {
        let contacts = null;
        if (activeRegion.Contacts != null) {
            contacts = activeRegion.Contacts;
        }
        return contacts;
}

    fitToMarkers(bounds)
    {
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }

        this.map.fitBounds(bounds);
    }

    getDirectionDistanceToDealers(dealers, userLocation, closestDealersBounds)
    {
        var directionsService = new google.maps.DirectionsService();
        var dealersWithDirectionDistance = [];
        var dealersLength = dealers.length;
        dealers.forEach(dealer => {
            let request = {
                origin: userLocation,
                destination: { lat: dealer.Lat, lng: dealer.Long },
                travelMode: "DRIVING"
            }

            directionsService.route(request, (result, status) => {
                    if (status === 'OK') {
                        dealer.Distance = result.routes[0].legs[0].distance;
                        dealersWithDirectionDistance.push(dealer);
                        closestDealersBounds.extend({ lat: dealer.Lat, lng: dealer.Long });

                        if (dealersWithDirectionDistance.length === dealersLength) {
                            var sortedDealers = sortDealersWithDirections(dealersWithDirectionDistance);
                            if (this.state.geoLocationSuccess) {
                                this.props.handleSearch();
                            }
                            this.setState({
                                showClosestDealers: true,
                                noDealersFound: false,
                                closestDealers: sortedDealers,
                                searchOrigin: userLocation,
                                closestDealersBounds: closestDealersBounds
                            });
                        }
                    } else if (status === "OVER_QUERY_LIMIT") {
                        dealersLength--;
                    }
                });
        });
    }

    createSearchOriginMarker(searchOrigin)
    {
        var searchLocationMarker = new google.maps.Marker({
            position: searchOrigin,
            icon: {
                url: "/Frontend/images/my-position-16px-radie3.png",
                scaledSize: {
                    width: 46,
                    height: 46
                },
                anchor : {
                    x: 23,
                    y: 23
                },
            },
            map: this.map,
        });
        this.markers.push(searchLocationMarker);
    }

    createMarkersForDealers(dealers){
        dealers.forEach((dealer) => {
            if(!dealer.IsInternational){
                var marker = new google.maps.Marker({
                    position: {lat: dealer.Lat, lng: dealer.Long},
                    animation: google.maps.Animation.DROP,
                    icon: {
                        url: markerIconDealer,
                        scaledSize: {
                            width: 32,
                            height: 32
                        },
                    }
                });
                marker.id = dealer.Id;
                marker.addListener('click', (event) => this.props.onDealerClick(dealer, event));
                this.markers.push(marker);
            }
        });
        var clusterStyles = [
            {
                url: clustermarkerImagePath + "1.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "2.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "3.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "4.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "5.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            }
        ];
        if(dealers.length){
            this.markerClusters.push(new MarkerClusterer(this.map, this.markers,
                {
                    maxZoom: 6,
                    styles: clusterStyles
                }));
        }
    }

    createMarkersForContacts(dealers) {
        dealers.forEach((dealer) => {
            if (!dealer.IsInternational) {
                var marker = new google.maps.Marker({
                    position: {lat: dealer.Lat, lng: dealer.Long},
                    animation: google.maps.Animation.DROP,
                    icon: {
                        url: markerIconContact,
                        scaledSize: {
                            width: 32,
                            height: 32
                        },
                    }
                });
                marker.id = dealer.Id;
                marker.addListener('click', (event) => this.props.onDealerClick(dealer, event));
                this.markers.push(marker);
            }
        });
        var clusterStyles = [
            {
                url: clustermarkerImagePath + "1.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "2.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "3.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "4.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            },
            {
                url: clustermarkerImagePath + "5.png",
                height: 32,
                width: 32,
                textColor: "#ffffff"
            }
        ];
        if (dealers.length) {
            this.markerClusters.push(new MarkerClusterer(this.map, this.markers,
                {
                    maxZoom: 6,
                    styles: clusterStyles
                }));
        }
    }

    clearMarkers(){
        if(this.markerClusters !== undefined){
            this.markerClusters.map((cluster) => {
                cluster.clearMarkers();
            });
        }
        this.markers.map((marker) => {
            marker.setMap(null);
        });
        this.markers = [];
    }
}